import strFunc from "@/lib/lyg/string";

function TotalArea(props: any) {
  let myProps = {
    Style: {},
    word_pre_info: null,
    ...props
  };
  let Style = myProps.Style;
  let word_pre_info = myProps.word_pre_info;

  let init_date_str = "";
  let last_update_date_str = "";
  let study_time_str = "";
  let study_time_total_str = "";
  if (word_pre_info && word_pre_info.group_stu_info) {
    if (word_pre_info.group_stu_info.a_update_date) {
      init_date_str = word_pre_info.group_stu_info.a_start_date;
      last_update_date_str = word_pre_info.group_stu_info.a_update_date;
    }
    if (word_pre_info.group_stu_info.a_elepse_time_sec) {
      let row_time_json: any = strFunc.secondsToTimeJson(word_pre_info.group_stu_info.a_elepse_time_sec);
      study_time_str = row_time_json.i + ":" + row_time_json.s;
      if (row_time_json.h != "00") {
        study_time_str = row_time_json.h + ":" + study_time_str;
      }
    }
    if (word_pre_info.group_stu_info.a_elepse_time_sec_tot) {
      let row_time_json: any = strFunc.secondsToTimeJson(word_pre_info.group_stu_info.a_elepse_time_sec_tot);
      study_time_total_str = row_time_json.i + ":" + row_time_json.s;
      if (row_time_json.h != "00") {
        study_time_total_str = row_time_json.h + ":" + study_time_str;
      }
    }
  }

  return (
    <div className={Style.total_summary}>
      <div className={Style.total_info_row}>
        <span className={Style.total_label}>시작</span>
        <span className={Style.total_value}>{init_date_str}</span>
      </div>
      <div className={Style.total_info_row}>
        <span className={Style.total_label}>마지막 기록</span>
        <span className={Style.total_value}>{last_update_date_str}</span>
      </div>
      <div className={Style.total_info_row}>
        <span className={Style.total_label}>학습 시간</span>
        <span className={Style.total_value}>{study_time_str}</span>
        <span className={Style.total_sub_value}>(누적: {study_time_total_str})</span>
      </div>
    </div>
  );
};
export default TotalArea;